// import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
// import Button from "react-bootstrap/Button";
import { IoReorderThree } from "react-icons/io5";
import { Checkbox } from "antd";
import Sidebar from "../../Components/Sidebar";
import overview from "../../assest/1.png";
import targetgroup from "../../assest/2.png";
import targetuser from "../../assest/3.png";
import edit from "../../assest/Button.png";
import deletebtn from "../../assest/newButton.png";
import addcircle from "../../assest/add-circle.png";
import AddUserModal from "../../Components/Modal/AddUsermodal";
import { useEffect, useState } from "react";
import CreateUserGroupModal from "../../Components/Modal/CreateUserGroup";
import DeleteModal from "../../Components/Modal/Deletemodal";
import DeleteNotification from "../../Components/Notification/DeleteNotification";
import AddedNotification from "../../Components/Notification/AddedNotification";
import { Link, useNavigate } from "react-router-dom";
import EditModal from "../../Components/Modal/EditModal";
import UpdateNotification from "../../Components/Notification/UpdateNotification";
import EditGroup from "../../Components/Modal/EditGroup";
import EditCampaign from "../../Components/Modal/EditCampaign";
import { getAllUser, getUser } from "../../redux/actions/authAction";
import { useSelector } from "react-redux";
import { getUserGroup } from "../../redux/actions/groupcampaignAction";
import { getCampaign } from "../../redux/actions/campaignaction";
import moment from "moment";
import { getfreeuser } from "../../redux/actions/freeuserAction";
import DeleteUsermodal from "../../Components/Modal/DeleteUsermodal";
import DeleteGroupmodal from "../../Components/Modal/DeleteGroupModal";
import EditUserModal from "../../Components/Modal/MultiEdit/EditUserModal";
import EditMultiGroup from "../../Components/Modal/MultiEdit/EditMultiGroup";
import { Input } from "antd";
import check from "../../assest/check.png";

const Dashboard = () => {
  const navigation = useNavigate();

  const { Search } = Input;

  const usergroup = useSelector((state) => state?.Groupreducer?.AllusersGroups);

  const allcampaign = useSelector(
    (state) => state?.campaignReducer?.Allcampaign
  );

  const freeuser = useSelector((state) => state?.freeuserReducer?.allfreeusers);
  const userdetails = useSelector((state) => state?.Auth?.userDetails?.user);
  const [addusermodalVisible, setAddUserModalVisible] = useState(false);
  const [addgroupusermodalVisible, setAddGroupUserModalVisible] =
    useState(false);
  const [notificationmodal, setNotificationmodal] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [groupmodalVisible, setGroupModalVisible] = useState(false);
  const [editmodalVisible, setEditModalVisible] = useState(false);
  const [editgroupmodalVisible, setEditGroupModalVisible] = useState(false);
  const [editcampaignmodalVisible, setEditcampaignModalVisible] =
    useState(false);
  const [editnotificationmodal, setEditNotificationmodal] = useState(false);
  const [deletenotificationmodal, setDeleteNotificationmodal] = useState(false);
  const [checked, setchecked] = useState([]);
  const [phishingchecked, setPhishingchecked] = useState([]);
  const [selectedCampaignId, setSelectedCampaignId] = useState([]);
  // const [editCampagin, SeteditCampagin] = useState(null)
  const [editfreeuser, Seteditfreeuser] = useState(null);
  const [deletefreeuser, Setdeletefreeuser] = useState(false);
  const [userchecked, setUserchecked] = useState([]);
  const [deletecomp, setDeletecomp] = useState([]);
  const [multieditmodalVisible, setMultiEditModalVisible] = useState(false);
  const [multieditfreeuser, setMultieditfreeuser] = useState([]);
  const [multicampaign, setMultiCampagin] = useState([]);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [multieditgroupmodalVisible, setMultiEditGroupModalVisible] =
    useState(false);
  const [multieditgroup, setMultieditgroup] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllfreeuser, setSelectAllFreeuser] = useState(false);
  const [selectAllusergroup, setSelectAllUsergroup] = useState(false);
  const [editgroup, setEditGroup] = useState(null);

  const navigate = useNavigate();

  const handleSelectAllChange = () => {
    if (selectAll) {
      // If selectAll is true, deselect all
      setPhishingchecked([]);
    } else {
      // If selectAll is false, select all campaigns
      setPhishingchecked(
        allcampaign?.usercampaign?.map((campaign) => campaign._id)
      );
      setSelectedCampaignId(
        allcampaign?.usercampaign?.map((campaign) => campaign._id)
      );
    }
    setSelectAll(!selectAll);
  };

  const handleSelectAllUserGrouChange = () => {
    if (selectAllusergroup) {
      // If selectAll is true, deselect all
      setUserchecked([]);
    } else {
      // If selectAll is false, select all campaigns
      setUserchecked(usergroup?.usergroup?.map((campaign) => campaign._id));
      setMultieditgroup(usergroup?.usergroup?.map((campaign) => campaign));
    }
    setSelectAllUsergroup(!selectAllusergroup);
  };

  const handleSelectAllFreeuserChange = () => {
    if (selectAllfreeuser) {
      // If selectAll is true, deselect all
      setchecked([]);
    } else {
      // If selectAll is false, select all campaigns
      setchecked(freeuser?.freeuser?.map((campaign) => campaign._id));
      setMultieditfreeuser(freeuser?.freeuser?.map((campaign) => campaign));
    }
    setSelectAllFreeuser(!selectAllfreeuser);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let organizationid = localStorage.getItem("organizationid");
        // let page = 1;
        let payload = { organizationid };

        // Await each function one after the other
        await getAllUser();
        await getUser(organizationid);
        await getUserGroup(payload);
        await getCampaign(payload);
        await getfreeuser(payload);
        // await GetMyOrganizationUser(myorganizationpayload);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Call the fetchData function
  }, []);

  const onSearch = async (value) => {
    try {
      let combinedSearch = value;
      if (multieditfreeuser.length > 0) {
        const names = multieditfreeuser.map((user) => user.Name).join(", ");

        combinedSearch += ", " + names;
      }

      let payload = {
        organizationid: userdetails?.organizationid,
        search: combinedSearch,
      };

      // let payload = {
      //     organizationid: userdetails.organizationid,
      //     search: value,

      // }

      await getfreeuser(payload);
    } catch (error) {
      console.log("error", error);
    }
  };

  const onGroupSearch = async (value) => {
    try {
      let combinedSearch = value;
      if (multieditgroup.length > 0) {
        const names = multieditgroup.map((user) => user.name).join(", ");

        combinedSearch += ", " + names;
      }

      let payload = {
        organizationid: userdetails?.organizationid,
        search: combinedSearch,
      };

      await getUserGroup(payload);
    } catch (error) {
      console.log("error", error);
    }
  };

  const onCompaingSearch = async (value) => {
    try {
      let combinedSearch = value;

      if (multicampaign.length > 0) {
        combinedSearch += ", " + multicampaign.join(", ");
      }

      let payload = {
        organizationid: userdetails?.organizationid,
        search: combinedSearch,
      };
      await getCampaign(payload);
    } catch (error) {
      console.log("error", error);
    }
  };

  const onChange = (e, campaign) => {
    const { checked } = e.target;

    // Update the selected checkboxes state
    setchecked((prevSelected) => {
      if (checked) {
        // Add campaign.id to the selected checkboxes
        return [...prevSelected, campaign._id];
      } else {
        // Remove campaign.id from the selected checkboxes
        return prevSelected.filter((id) => id !== campaign._id);
      }
    });

    setMultieditfreeuser((prevSelected) => {
      if (checked) {
        // Add campaign.id to the selected checkboxes
        return [...prevSelected, campaign];
      } else {
        // Remove campaign.id from the selected checkboxes
        return prevSelected.filter((id) => id !== campaign);
      }
    });
  };
  const UsergrouponChange = (e, campaign) => {
    const { checked } = e.target;

    // Update the selected checkboxes state
    setUserchecked((prevSelected) => {
      if (checked) {
        // Add campaign.id to the selected checkboxes
        return [...prevSelected, campaign._id];
      } else {
        // Remove campaign.id from the selected checkboxes
        return prevSelected.filter((id) => id !== campaign._id);
      }
    });

    setMultieditgroup((prevSelected) => {
      if (checked) {
        // Add campaign.id to the selected checkboxes
        return [...prevSelected, campaign];
      } else {
        // Remove campaign.id from the selected checkboxes
        return prevSelected.filter((id) => id !== campaign);
      }
    });
  };

  const phisingonChange = (e, campaign) => {
    const { checked } = e.target; // Extract the 'checked' value from the event

    setPhishingchecked((prevSelected) => {
      let updatedSelection;
      let multicampaignselection;
      if (checked) {
        // Add campaign._id to the selected checkboxes
        updatedSelection = [...prevSelected, campaign._id];
        multicampaignselection = [...prevSelected, campaign.name];
      } else {
        // Remove campaign._id from the selected checkboxes
        updatedSelection = prevSelected.filter((id) => id !== campaign._id);
        multicampaignselection = prevSelected.filter(
          (id) => id !== campaign.name
        );
      }

      // Now update selectedCampaignId correctly
      setSelectedCampaignId(updatedSelection);
      setMultiCampagin(multicampaignselection);

      // Return the updated array to ensure correct state update
      return updatedSelection;
    });
  };

  const adduserbtn = () => {
    setAddUserModalVisible(true);
  };

  const addGroupuset = () => {
    setAddGroupUserModalVisible(true);
  };

  const multiedituser = () => {
    // setMultieditfreeuser(campaign)
    setMultiEditModalVisible(true);
  };

  const editmodal = (campaign) => {
    Seteditfreeuser(campaign);
    setEditModalVisible(true);
  };

  const editcompmodal = (campaign) => {
    navigate("/campaignflow", {
      state: { campaign: campaign },
    });
  };

  const editGroupmodal = (group) => {
    setEditGroup(group);
    setEditGroupModalVisible(true);
  };

  const deletemodal = (id) => {
    setchecked((prevState) => {
      if (!prevState.includes(id)) {
        return [...prevState, id];
      }
      return prevState;
    });

    Setdeletefreeuser(true);
    // setModalVisible(true)
  };

  const deletecompmodal = (id) => {
    // setSelectedCampaignId((prevState) => [...prevState, id]);
    setSelectedCampaignId((prevState) => {
      // Add id to the selected campaign IDs, if not already present
      if (!prevState.includes(id)) {
        return [...prevState, id];
      }
      return prevState;
    });

    setModalVisible(true);
    setDeletecomp(true);
  };

  const deletgroupmodal = (id) => {
    setUserchecked((prevState) => {
      // Add id to the selected campaign IDs, if not already present
      if (!prevState.includes(id)) {
        return [...prevState, id];
      }
      return prevState;
    });
    setGroupModalVisible(true);
  };
  return (
    <>
      <div className="dashboard">
        <Sidebar show={show} setShow={setShow} />
        <div className="dashboard-right-side">
          <div className="headerbox">
            <div className="d-flex align-items-center">
              <button
                className="d-block d-lg-none bg-transparent text-dark border border-0"
                onClick={handleShow}
              >
                <IoReorderThree size={30} />
              </button>
              <div className="headertext">Overview</div>
            </div>

            <div
              onClick={() => {
                navigation("/campaignflow");
              }}
              className="createcampaignbutton"
            >
              <img alt="" className="createcampaignimg" src={addcircle}></img>
              Create New Campaign
            </div>
          </div>
          <div className="row mt-3">
            {/* Card 1 - Total Campaigns */}
            <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
              <div className="d-flex justify-content-between pt-4 statsbox px-4 h-100">
                <div className="statsheading">
                  <p className="statSize mb-1 text-muted">Total Campaigns</p>
                  <h1>{allcampaign?.campaigncount || 0}</h1>
                </div>
                <img className="statsimg" src={overview} alt="Overview" />
              </div>
            </div>

            {/* Card 2 - Total Target Users */}
            <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
              <div className="d-flex justify-content-between pt-4 statsbox p-4 h-100">
                <div className="statsheading">
                  <p className="statSize mb-1 text-muted">Total Target Users</p>
                  <h1>{freeuser?.freeusercount || 1}</h1>
                </div>
                <img
                  className="statsimg"
                  src={targetgroup}
                  alt="Target Group"
                />
              </div>
            </div>

            {/* Card 3 - Total User Groups */}
            <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
              <div className="d-flex justify-content-between pt-4 statsbox p-4 h-100">
                <div className="statsheading">
                  <p className="statSize mb-1 text-muted">Total User Groups</p>
                  <h1>{usergroup?.usergroupcount || 1}</h1>
                </div>
                <img className="statsimg" src={targetuser} alt="Target User" />
              </div>
            </div>
          </div>

          <div className="phisingcampaigns ">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p className="name">Phishing Simulation Campaigns</p>

              <div className="d-flex">
                <div className="d-flex">
                  {phishingchecked.length > 1 && (
                    <>
                      {/* <img
                                                alt=""
                                                // style={{ position: 'relative', cursor: 'pointer', top: '14px', left: '34%' }}
                                                style={{ cursor: 'pointer' }}
                                                width={25}
                                                height={25}
                                                src={edit}
                                                onClick={editcompmodal}
                                            /> */}

                      <img
                        alt=""
                        style={{ cursor: "pointer" }}
                        // style={{ position: 'relative', cursor: 'pointer', top: '14px', left: '17%' }}
                        width={25}
                        height={25}
                        src={deletebtn}
                        onClick={deletecompmodal}
                      />
                    </>
                  )}
                </div>

                <div style={{ marginBottom: "28px" }} className="searchbox">
                  <Search
                    placeholder="Search campaigns...."
                    onSearch={onCompaingSearch}
                    onPressEnter={(e) => onCompaingSearch(e.target.value)}
                    enterButton
                    className="h-[41px] [&>span>input]:h-[41px] [&_.ant-btn]:h-[41px] [&_.ant-btn]:flex [&_.ant-btn]:items-center"
                  />
                </div>
              </div>
            </div>
            <div className="">
              <div>
                <div className="min-w-[690px] mainphisingcampaigns flex flex-wrap items-center border-b p-2">
                  <div className="w-[6%]">
                    <Checkbox
                      checked={selectAll}
                      onChange={handleSelectAllChange}
                      className="pt-2"
                    />
                  </div>
                  <div className="w-[20%]">Campaign ID</div>
                  <div className="w-[22%]">Campaign Name</div>
                  <div className="w-[25%]">Date & Time</div>
                  <div className="w-[15%]">Users</div>
                  <div className="w-[10%]">Action</div>
                </div>

                {allcampaign?.usercampaign
                  ?.slice() // Create a copy to avoid mutating the original array
                  .sort((a, b) => {
                    const dateA = new Date(a.createdDate || 0);
                    const dateB = new Date(b.createdDate || 0);
                    return dateB - dateA; // Descending order (newest first)
                  })
                  .map((campaign, index) => (
                    <Link
                      key={index}
                      to={`/dashboard/my-campaigns/${campaign._id}`}
                      className="phisingcampaignsdescription hover:bg-gray-50 flex flex-row border-b p-2 min-w-[700px] no-underline"
                    >
                      <div className="w-[6%]">
                        <Checkbox
                          onChange={(e) => phisingonChange(e, campaign)}
                          checked={phishingchecked.includes(campaign._id)}
                        />
                      </div>
                      <div className="w-[18%]">{campaign._id.slice(-6)}</div>
                      <div className="w-[16%]">{campaign.name}</div>
                      <div className="w-[20%]">
                        {moment(campaign?.createdDate)
                          .local()
                          .format("MMM D, YYYY hh:mm A z")}
                      </div>
                      <div className="w-[20%]">
                        {campaign?.usercampaign?.[0]?.targetGroup?.length > 0
                          ? `${campaign.userCount}`
                          : `1`}{" "}
                        Users
                      </div>
                      <div className="w-[10%] flex gap-2 items-center h-5">
                        {campaign?.campaignStatus === "sent" ? (
                          <img src={check} alt="check" className="h-5 w-5" />
                        ) : (
                          <div className="">
                            <img
                              onClick={(e) => {
                                e.preventDefault();
                                const now = new Date();
                                const campaignDate = new Date(
                                  campaign.createdDate
                                );
                                if (campaignDate < now) return;
                                editcompmodal(campaign);
                              }}
                              src={edit}
                              alt="Edit"
                              className={`cursor-pointer h-6 w-6 ${
                                new Date(campaign.createdDate) < new Date()
                                  ? "opacity-50 cursor-not-allowed"
                                  : ""
                              }`}
                            />
                            <img
                              onClick={(e) => {
                                e.preventDefault();
                                deletecompmodal(campaign._id);
                              }}
                              src={deletebtn}
                              alt="Delete"
                              className="cursor-pointer h-6 w-6 mx-2"
                            />
                          </div>
                        )}
                      </div>
                    </Link>
                  ))}
              </div>
              <div
                onClick={() => navigate("/dashboard/my-campaigns")}
                className="flex  justify-start lg:justify-end mr-1 mt-2 text-[15px] font-normal text-red-500 underline cursor-pointer"
              >
                View All
              </div>
            </div>
          </div>

          <div
            className="row"
            style={{
              marginTop: "20px",
            }}
          >
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div
                style={{ marginBottom: "24px" }}
                className="phisingcampaigns"
              >
                <div className="usercampaign-main-div">
                  <p className="stattSize">Individual Users</p>
                  <div className="d-flex">
                    <div style={{ marginBottom: "20px" }} className="d-flex">
                      {checked.length > 1 && (
                        <>
                          <img
                            alt=""
                            style={{ cursor: "pointer" }}
                            // style={{ position: 'relative', cursor: 'pointer', left: '34%', top: '14px' }}
                            width={25}
                            height={25}
                            src={edit}
                            onClick={multiedituser}
                          />

                          <img
                            alt=""
                            style={{ cursor: "pointer" }}
                            // style={{ position: 'relative', cursor: 'pointer', left: '17%', top: '14px' }}
                            width={25}
                            height={25}
                            src={deletebtn}
                            onClick={deletemodal}
                          />
                        </>
                      )}
                    </div>
                    <div onClick={adduserbtn} className="usercampaign w-full">
                      <img
                        alt=""
                        className="createcampaignimg"
                        src={addcircle}
                      ></img>
                      New User
                    </div>
                  </div>
                </div>

                <div style={{ marginBottom: "13px" }} className="searchbox">
                  <Search
                    placeholder="Search user...."
                    onSearch={onSearch}
                    onPressEnter={(e) => onSearch(e.target.value)}
                    enterButton
                    className="h-[41px] [&>span>input]:h-[41px] [&_.ant-btn]:h-[41px] [&_.ant-btn]:flex [&_.ant-btn]:items-center"
                  />
                </div>
                <div className="mainphisingcampaigns">
                  <div style={{ width: "6%" }}>
                    <Checkbox
                      checked={selectAllfreeuser}
                      onChange={handleSelectAllFreeuserChange}
                      className="pt-2"
                    ></Checkbox>
                  </div>

                  <div style={{ width: "21%" }}>User ID</div>
                  <div style={{ width: "58%" }}>Name</div>
                  <div style={{ width: "28%" }}>Role</div>

                  <div>Action</div>
                </div>

                {freeuser?.freeuser?.map((campaign, index) => (
                  <div key={index} className="phisingcampaignsdescription">
                    <div style={{ width: "6%" }}>
                      <Checkbox
                        onChange={(e) => onChange(e, campaign)}
                        checked={checked.includes(campaign._id)}
                      ></Checkbox>
                    </div>
                    <div style={{ width: "21%" }}>{`ST000${index + 1}`}</div>
                    <div style={{ width: "58%" }}>{campaign.name}</div>

                    <div style={{ width: "28%" }}>{campaign.role}</div>
                    <div className="actions">
                      <img
                        onClick={() => editmodal(campaign)}
                        actions
                        src={edit}
                        alt="Edit"
                      />
                      <img
                        onClick={() => deletemodal(campaign._id)}
                        src={deletebtn}
                        alt="Delete"
                      />
                    </div>
                  </div>
                ))}
                <div
                  onClick={() => {
                    navigate("/dashboard/target-users");
                  }}
                  className="viewall"
                >
                  View All
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div
                style={{ marginBottom: "24px" }}
                className="phisingcampaigns"
              >
                {/* <p>
                            User Groups
                        </p> */}

                <div className="usercampaign-main-div">
                  <p>Groups</p>
                  <div className="d-flex">
                    <div style={{ marginBottom: "20px" }} className="d-flex">
                      {userchecked.length > 1 && (
                        <>
                          <img
                            alt=""
                            style={{ cursor: "pointer" }}
                            // style={{ position: 'relative', cursor: 'pointer', left: '34%', top: '14px' }}
                            width={25}
                            height={25}
                            src={edit}
                            onClick={() => {
                              setMultiEditGroupModalVisible(true);
                            }}
                          />
                          <img
                            alt=""
                            style={{ cursor: "pointer" }}
                            // style={{ position: 'relative', cursor: 'pointer', left: '17%', top: '14px' }}
                            width={25}
                            height={25}
                            src={deletebtn}
                            onClick={deletgroupmodal}
                          />
                        </>
                      )}
                    </div>
                    <div onClick={addGroupuset} className="usercampaign">
                      <img
                        alt=""
                        className="createcampaignimg"
                        src={addcircle}
                      ></img>
                      Create Group
                    </div>
                  </div>
                </div>
                <div style={{ marginBottom: "13px" }} className="searchbox">
                  <Search
                    placeholder="Search group...."
                    onSearch={onGroupSearch}
                    onPressEnter={(e) => onGroupSearch(e.target.value)}
                    enterButton
                    className="h-[41px] [&>span>input]:h-[41px] [&_.ant-btn]:h-[41px] [&_.ant-btn]:flex [&_.ant-btn]:items-center"
                  />
                </div>

                <div className="mainphisingcampaigns">
                  <div style={{ width: "7%", marginTop: "6px" }}>
                    <Checkbox
                      checked={selectAllusergroup}
                      onChange={handleSelectAllUserGrouChange}
                    ></Checkbox>
                  </div>

                  <div style={{ width: "80%" }}>Group Name</div>
                  <div>Members</div>

                  <div>Action</div>
                </div>

                {usergroup?.usergroup?.map((campaign, index) => (
                  <div key={index} className="phisingcampaignsdescription">
                    <div style={{ width: "7%" }}>
                      <Checkbox
                        onChange={(e) => UsergrouponChange(e, campaign)}
                        checked={userchecked.includes(campaign._id)}
                      ></Checkbox>
                    </div>

                    <div style={{ width: "80%" }}>{campaign?.name}</div>

                    <div>{campaign?.userCount} Users</div>

                    <div className="actions">
                      <img
                        onClick={() => editGroupmodal(campaign)}
                        actions
                        src={edit}
                        alt="Edit"
                      />
                      <img
                        onClick={() => deletgroupmodal(campaign._id)}
                        src={deletebtn}
                        alt="Delete"
                      />
                    </div>
                  </div>
                ))}

                <div
                  onClick={() => {
                    // navigate('/dashboard/target-users')
                    navigate("/dashboard/target-users", {
                      state: { usergroup: true },
                    });
                  }}
                  className="viewall"
                >
                  View All
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddUserModal
        visible={addusermodalVisible}
        onClose={() => setAddUserModalVisible(false)}
        setNotificationmodal={setNotificationmodal}
      />

      <CreateUserGroupModal
        visible={addgroupusermodalVisible}
        onClose={() => setAddGroupUserModalVisible(false)}
      />

      <DeleteModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        // currentRoute={currentRoute}
        setNotificationmodal={setDeleteNotificationmodal}
        deletecomp={deletecomp}
        selectedCampaignId={selectedCampaignId}
      />

      <DeleteNotification
        visible={deletenotificationmodal}
        onClose={() => setDeleteNotificationmodal(false)}
        deletecomp={deletecomp}
      />

      <DeleteUsermodal
        visible={deletefreeuser}
        onClose={() => Setdeletefreeuser(false)}
        deletecomp={deletecomp}
        checked={checked}
        setchecked={setchecked}
        setNotificationmodal={setDeleteNotificationmodal}
        multieditfreeuser={multieditfreeuser}

        // setNotificationmodal={setDeleteNotificationmodal}
      />

      <AddedNotification
        visible={notificationmodal}
        onClose={() => setNotificationmodal(false)}
      />

      <EditModal
        visible={editmodalVisible}
        onClose={() => setEditModalVisible(false)}
        setEditNotificationmodal={setEditNotificationmodal}
        editfreeuser={editfreeuser}
      />

      <EditUserModal
        visible={multieditmodalVisible}
        onClose={() => setMultiEditModalVisible(false)}
        setEditNotificationmodal={setEditNotificationmodal}
        editfreeuser={multieditfreeuser}
        setMultieditfreeuser={setMultieditfreeuser}
        setchecked={setchecked}
        setSelectAllFreeuser={setSelectAllFreeuser}
      />

      <EditCampaign
        visible={editcampaignmodalVisible}
        onClose={() => setEditcampaignModalVisible(false)}
        //    currentRoute={}
        setEditNotificationmodal={setEditNotificationmodal}
        // editCampagin={editCampagin}
      />

      <EditGroup
        visible={editgroupmodalVisible}
        onClose={() => setEditGroupModalVisible(false)}
        //    currentRoute={}
        setEditNotificationmodal={setEditNotificationmodal}
        editgroup={editgroup}
      />

      <EditMultiGroup
        visible={multieditgroupmodalVisible}
        onClose={() => setMultiEditGroupModalVisible(false)}
        //    currentRoute={}
        setEditNotificationmodal={setEditNotificationmodal}
        editgroup={multieditgroup}
        setMultieditgroup={setMultieditgroup}
        setUserchecked={setUserchecked}
      />

      <UpdateNotification
        visible={editnotificationmodal}
        onClose={() => setEditNotificationmodal(false)}
      />

      <DeleteGroupmodal
        visible={groupmodalVisible}
        onClose={() => setGroupModalVisible(false)}
        setNotificationmodal={setNotificationmodal}
        deletegroup={userchecked}
        setUserchecked={setUserchecked}
        setMultieditgroup={setMultieditgroup}
      />
    </>
  );
};

export default Dashboard;
